var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 2.33169L1.06635 25.0198C0.829723 25.4295 0.705122 25.8943 0.705078 26.3674C0.705034 26.8405 0.829549 27.3054 1.0661 27.7151C1.30266 28.1249 1.64292 28.4651 2.05267 28.7017C2.46243 28.9383 2.92724 29.0628 3.40038 29.0627H29.5981C30.0712 29.0628 30.5361 28.9383 30.9458 28.7017C31.3556 28.4651 31.6958 28.1249 31.9324 27.7151C32.1689 27.3054 32.2935 26.8405 32.2934 26.3674C32.2934 25.8943 32.1688 25.4295 31.9321 25.0198L18.8336 2.33169C18.5971 1.92205 18.2569 1.58189 17.8473 1.34538C17.4376 1.10888 16.973 0.984375 16.4999 0.984375C16.0269 0.984375 15.5623 1.10888 15.1526 1.34538C14.743 1.58189 14.4028 1.92205 14.1663 2.33169Z",
    fill: "#F62634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6707 9.32812H16.329C15.4877 9.32812 14.8057 10.0101 14.8057 10.8514V18.1327C14.8057 18.974 15.4877 19.656 16.329 19.656H16.6707C17.512 19.656 18.194 18.974 18.194 18.1327V10.8514C18.194 10.0101 17.512 9.32812 16.6707 9.32812Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 25.4313C17.4355 25.4313 18.194 24.6728 18.194 23.7371C18.194 22.8015 17.4355 22.043 16.4998 22.043C15.5642 22.043 14.8057 22.8015 14.8057 23.7371C14.8057 24.6728 15.5642 25.4313 16.4998 25.4313Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.92130eca3756403a7cb3564220fef747.svg";
export { ForwardRef as ReactComponent };